import * as Website from '../../Config/Website.js';
import reservation from './Modules/Reservation.js';
import * as ViewMore from './Modules/ViewMore.js';
import * as Splash from './Modules/Splash.js';
import * as Accordion from '../../Modules/Accordion.js';


const preinit = () => {

}

const init = () => {
  reservation();
  ViewMore.init();
  Accordion.init();
  Accordion.css();
}

const resize = () => {
  Accordion.css();
}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {
  Splash.init();
  Accordion.css();
}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}